<!--
 * @Author: Mr.Cong Wei
 * @Date: 2022-12-12 16:58:48
 * @LastEditTime: 2022-12-12 17:04:15
-->
<template>
  <span class="anticon anticon-down" role="img">
    <svg
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="18px"
      height="11px"
    >
      <g transform="matrix(1 0 0 1 -481 -641 )">
        <path
          d="M 2.1910714285714334 0.45459183673464415  L 9 7.582142857142862  L 15.803571428571502 0.44897959183676656  C 16.307142857142935 -0.0785714285714241  17.121428571428567 -0.0785714285714241  17.619642857142935 0.44897959183676656  C 18.117857142857048 0.9765306122448457  18.117857142857048 1.829591836734644  17.619642857142935 2.357142857142857  L 9.91071428571442 10.438775510204097  C 9.423214285714437 10.949489795918389  8.64107142857145 10.9607142857143  8.137500000000017 10.47806122448982  L 0.375 2.3627551020408686  C 0.12321428571436854 2.0989795918367844  0 1.7510204081632201  0 1.4086734693876892  C 0 1.066326530612315  0.12321428571436854 0.7183673469387507  0.375 0.45459183673464415  C 0.8785714285714334 -0.0729591836734126  1.692857142857065 -0.0729591836734126  2.1910714285714334 0.45459183673464415  Z "
          fill-rule="nonzero"
          fill="#006ab2"
          stroke="none"
          transform="matrix(1 0 0 1 481 641 )"
        />
      </g>
    </svg>
  </span>
</template>

<script setup lang="ts"></script>

<style scoped></style>
